module.exports = __webpack_public_path__ + "static/media/finlandia-foundation-logo.0bb6197b.png";